import createReactClass from 'create-react-class';
import _ from 'lodash';
import React from 'react';
import InputMixin from '../../../../mixins/input-mixin';
import NumericMixin from '../../../../mixins/numeric-mixin';
import PublishMixin from '../../../../mixins/publish-mixin';

const Decimal = createReactClass({
  displayName: 'Decimal',
  mixins: [PublishMixin, InputMixin('input'), NumericMixin],

  getInitialState: function () {
    this.input = React.createRef();
    return {
      caret: -1,
      value: parseFloat(this.props.value.toString()).toFixed(this.props.decimals)
    };
  },

  getDefaultProps: function () {
    return {
      decimals: 2,
      value: 0
    };
  },

  UNSAFE_componentWillMount() {
    this.toDecimal(this.state.value || '0');
  },

  UNSAFE_componentWillReceiveProps: function (nextProps) {
    if (!_.eq(nextProps, this.props)) this.toDecimal(nextProps.value);
  },

  getInputNode: function () {
    return this.input.current;
  },

  componentDidUpdate: function (next) {
    if (this.state.caret > -1) {
      this.select(this.state.caret);
      // this fixes dialog caret position guff, we don't know why
      setTimeout(() => this.setState({ caret: -1 }), 0);
    }
  },

  prev: function (e, index) {
    if (index == 0) return;

    if (e.target.value.indexOf('.') == index - 1) {
      this.select(index - 1);
      e.preventDefault();
    }
  },

  next: function (e, index) {
    if (index >= e.target.value.length) return;

    if (e.target.value.indexOf('.') == index) {
      this.select(index + 1);
      e.preventDefault();
    }
  },

  onKeyDown: function (e) {
    var selStart = e.target.selectionStart;
    var selEnd = e.target.selectionEnd;

    //return as more than 1 char selected and is cut or overtype
    if (selStart != selEnd) return;

    switch (e.keyCode || e.which) {
      case 8: //backspace
        this.prev(e, selStart);
        break;
      case 46: //delete
      case 127:
      case 190:
      case 110:
        this.next(e, selEnd);
        break;
    }

    if (!!this.props.onKeyDown) this.props.onKeyDown(e);
  },

  onChange: function (e) {
    this.toDecimal(e.target.value, e.target.selectionStart, () => this.publish(this.state.value));
  },

  onFocus: function (e) {
    this.select(0, e.target.value.length);
    if (this.props.onFocus) this.props.onFocus(e);
    // this.input.current = e.target;
  },

  onMouseUp(e) {
    e.preventDefault();
  },

  render() {
    let { value } = this.state;

    var style = _.extend({}, { textAlign: 'right' }, this.props.style, this.props.inputStyle);

    if (this.props.readOnly) return <strong>{value}</strong>;

    return (
      <input
        type="text"
        ref={this.input}
        onFocus={this.onFocus}
        onBlur={this.props.onBlur}
        onChange={this.onChange}
        onMouseUp={this.onMouseUp}
        onKeyDown={this.onKeyDown}
        className={this.props.className}
        disabled={this.props.readOnly || this.props.disabled}
        value={value}
        style={style}
      />
    );
  }
});

export default Decimal;
